/**
 * @author caijianjia
 * @date 2024/6/1 9:07 下午
 */

import axios from 'axios'
// const base = 'http://cx.okweizhan.com/index.php'
const base = 'http://cx.ceeia.com/index.php'
// const base = 'http://localhost:8080/api/index.php'

// 获取用户信息
export function getUser () {
  return axios.get(`${base}?m=Home&c=User&a=detail`)
}

// 账号信息修改
export function updateUser ({ username, zzjg, frdb, gszcd }) {
  const data = new FormData()
  data.append('username', username)
  data.append('zzjg', zzjg)
  data.append('frdb', frdb)
  data.append('gszcd', gszcd)
  return axios({
    method: 'post',
    url: `${base}?m=Home&c=User&a=update`,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 登录
export function login ({ username, password }) {
  const data = new FormData()
  data.append('username', username)
  data.append('password', password)
  return axios({
    method: 'post',
    url: `${base}?m=Home&c=User&a=login`,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 退出
export function logout () {
  return axios.get(`${base}?m=Home&c=User&a=logout`)
}

// 修改密码
export function profile ({
  old,
  password,
  repassword
}) {
  const data = new FormData()
  const url = `${base}?m=Home&c=User&a=profile`
  data.append('old', old)
  data.append('password', password)
  data.append('repassword', repassword)
  return axios({
    method: 'post',
    url,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 上传文件
export function upload ({
  download
}) {
  const data = new FormData()
  const url = `${base}?m=Home&c=File&a=upload`
  data.append('download', download)
  return axios({
    method: 'post',
    url,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 批量上传项目申请
export function updatebat ({
  cert,
  uid,
  pid = '0',
  modelId = '231',
  categoryId = '18',
  isAjax = '1'
}) {
  const data = new FormData()
  data.append('cert', cert)
  data.append('uid', uid)
  data.append('pid', pid)
  data.append('model_id', modelId)
  data.append('category_id', categoryId)
  data.append('is_ajax', isAjax)
  return axios({
    method: 'post',
    url: `${base}?m=Admin&c=Article&a=updatebat`,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取公共数据
export function comm () {
  return axios.get(`${base}?m=Home&c=Index&a=comm`)
}

// 获取服务机构列表
export function getFwjgList ({ page, limit }) {
  return axios.get(`${base}?m=Home&c=Fwjg&a=getList&page=${page}&limit=${limit}`)
}

// 获取友情链接
export function getLinks () {
  return axios.get(`${base}?m=Home&c=Index&a=getLinks`)
}

// 获取列表
// model id:类型id 0:全部 224:新闻资讯 225:政策法规 226:信息发布 227:技术标准 228:认证规则
export function getList ({ page, limit, keyword = '', modeId }) {
  return axios.get(`${base}?m=Home&c=Index&a=getList&page=${page}&limit=${limit}&keyword=${keyword}&model_id=${modeId}`)
}

// 获取详情数据
export function getDetailById (id) {
  return axios.get(`${base}?m=Home&c=Index&a=detail&id=${id}`)
}

// 获取平台介绍
export function getPtjs () {
  return axios.get(`${base}?m=Home&c=Gywm&a=getPtjs`)
}

// 获取平台章程
export function getPtzc () {
  return axios.get(`${base}?m=Home&c=Gywm&a=getPtzc`)
}

// 获取平台架构
export function getZzjg () {
  return axios.get(`${base}?m=Home&c=Gywm&a=getZzjg`)
}

// 获取成员机构列表
export function getCyjgList ({ page, limit }) {
  return axios.get(`${base}?m=Home&c=Gywm&a=getCyjgList&page=${page}&limit=${limit}`)
}

// 提交机构申请
export function Jgsq ({ name, zzjg, frdb, gszcd, bgdz, ywfw, fwnr, lxrxm, lxrsjh, lxryx }) {
  // data:{
  //   "name": "公司名称",//公司名称
  //     "zzjg": "XXXXX",//组织机构代码
  //     "frdb": "蔡哈哈",//法人代表人姓名
  //     "gszcd": "公司注册地",//公司注册地
  //     "bgdz": "办公地址",//办公地址
  //     "ywfw": "业务范围",//业务范围
  //     "fwnr": "计划开展的服务内容",//计划开展的服务内容
  //     "lxrxm": "蔡呵呵",//申请联系人姓名
  //     "lxrsjh": "14758598390",//申请联系人手机号
  //     "lxryx": "caijiajia100@126.com",//申请联系人邮箱
  // }
  const data = new FormData()
  data.append('data', JSON.stringify({ name, zzjg, frdb, gszcd, bgdz, ywfw, fwnr, lxrxm, lxrsjh, lxryx }))
  return axios({
    method: 'post',
    url: `${base}?m=Home&c=Jgsq&a=add`,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  // return axios.post(`${base}?m=Home&c=Jgsq&a=add`, data)
}

// 获取机构申请详情
export function getJgsqDetailById ({ id }) {
  return axios.get(`${base}?m=Home&c=Jgsq&a=detail&id=${id}`)
}

// 获取机构列表
export function getJgsqList ({ name = '', ssgz = '', page, limit }) {
  // 入参:
  //   name:机构名称，可选
  //   ssgz:实施规则，可选
  //   page:当前页
  //   limit:每页条数
  return axios.get(`${base}?m=Home&c=Jgsq&a=getList&page=${page}&limit=${limit}&name=${name}&ssgz=${ssgz}`)
}

// 获取项目申请模版列表
export function getXmsqmbList () {
  return axios.get(`${base}?m=Home&c=Xmsqmb&a=getList`)
}

// 提交项目实施监督
export function xmssjdAdd ({ name, qymc, sjh, fkyjqymc, fkyjxmmc, fkyjjtms }) {
  // 入参:
  //   data:{
  //     "name":"蔡哈哈",//您的姓名
  //       "qymc":"您所在的企业名称",//您所在的企业名称
  //       "sjh":"14748958989",//您的手机号
  //       "fkyjqymc":"反馈意见对应的企业名称",//反馈意见对应的企业名称
  //       "fkyjxmmc":"反馈意见对应的项目名称",//反馈意见对应的项目名称
  //       "fkyjjtms":"反馈意见对应的具体描述"//反馈意见对应的具体描述
  //   }
  const data = new FormData()
  data.append('data', JSON.stringify({ name, qymc, sjh, fkyjqymc, fkyjxmmc, fkyjjtms }))
  return axios({
    method: 'post',
    url: `${base}?m=Home&c=xmssjd&a=add`,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 提交/更新证书报告申请
export function zsbgsqSave ({ id, zsbh, jgmc, xmmc, qymc, rzdx, zs }) {
  // 入参:
  //   data:{
  //     "id": 50,//证书报告申请id,有传该值，则为更新
  //       "zsbh": "XXXXX",//证书编号
  //       "jgmc": "发证机构名称",//发证机构名称
  //       "xmmc": "创新项目名称",//创新项目名称
  //       "qymc": "获证企业名称",//获证企业名称
  //       "rzdx": "认证对象",//认证对象
  //       "zs": "/Uploads/Download/2024-10-20/67149f16b55b0.pdf",//证书路径
  //   }
  const data = new FormData()
  data.append('data', JSON.stringify({ id: '', zsbh, jgmc, xmmc, qymc, rzdx, zs }))
  return axios({
    method: 'post',
    url: `${base}?m=Home&c=Zsbgsq&a=save`,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取证书报告申请详情
export function getZsbgsqDetailById (id = '') {
  return axios.get(`${base}?m=Home&c=Zsbgsq&a=detail&id=${id}`)
}

// 获取证书报告申请列表
export function getZsbgsqList ({
  zsbh,
  jgmc,
  xmmc,
  qymc,
  rzdx,
  page,
  limit
}) {
  // 入参:
  //   zsbh:证书编号
  //   jgmc:发证机构名称
  //   xmmc:创新项目名称
  //   qymc:获证企业名称
  //   rzdx:认证对象
  //   page:当前页
  //   limit:每页条数
  return axios.get(`${base}?m=Home&c=Zsbgsq&a=getList&page=${page}&limit=${limit}&zsbh=${zsbh}&jgmc=${jgmc}&xmmc=${xmmc}&qymc=${qymc}&rzdx=${rzdx}`)
}

// 提交/更新项目申请
export function xmsqSave ({
  id = '',
  name = '',
  attach1 = '',
  attach2 = '',
  attach3 = ''
}) {
  // 入参:
  //   data:{
  //     "id": 50,//项目申请id,有传该值，则为更新
  //       "name": "项目名称",//项目名称
  //       "attach1": "/Uploads/Download/2024-10-20/67149f16b55b0.pdf",//
  //       "attach2": "/Uploads/Download/2024-10-20/67149f16b55b0.pdf",//
  //       "attach3": "/Uploads/Download/2024-10-20/67149f16b55b0.pdf",//
  //   }
  const data = new FormData()
  data.append('data', JSON.stringify({
    id,
    name,
    attach1,
    attach2,
    attach3
  }))
  return axios({
    method: 'post',
    url: `${base}?m=Home&c=Xmsq&a=save`,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取项目申请列表
export function getXmsqList ({
  name,
  jgmc,
  page,
  limit
}) {
  // 入参:
  //   name:项目名称
  // jgmc:机构名称
  // page:当前页
  // limit:每页条数
  return axios.get(`${base}?m=Home&c=Xmsq&a=getList&page=${page}&limit=${limit}&name=${name}&jgmc=${jgmc}`)
}

// 获取项目申请列表
export function getXmsqDetailById (id = '') {
  // 入参:
  //   id:项目申请id，可选，为空时取最近一条
  return axios.get(`${base}?m=Home&c=Xmsq&a=detail&id=${id}`)
}

// 删除记录(删除项目管理申请/证书报告申请)
export function deleteRecord (id = '') {
  // 入参:
  //   id:项目申请id
  return axios.get(`${base}?m=Home&c=Index&a=delete&id=${id}`)
}
